<script>import Checkbox from "./checkbox.svelte";
export let element = void 0;
export let group = [];
export let value;
export let error = false;
</script>

<Checkbox
  bind:element
  {error}
  checked={group.includes(value)}
  on:change={() => {
    if (group.includes(value)) {
      group = group.filter((el) => el !== value);
    } else {
      group = [...group, value];
    }
  }}
  {...$$restProps}
/>
